import { getAllLockedEntityLegDecl } from '../../app/services/Declarations/getAllActiveEntityLegalDecl'
import { unLockDeclarations } from '../../app/services/Declarations/unLockEntityLegalDecl'
import { setErrorTextSnackBar, setRequestTextSnackBar } from './app'

export const getAllLockedDeclarations = (subId) => {
  return async (dispatch) => {
    try {
      const response = await getAllLockedEntityLegDecl(subId)

      return response.data.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: EntityLegalDeclarationApi'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return []
    }
  }
}

export const unLockEntityLegalDeclarations = (declId) => {
  return async (dispatch) => {
    try {
      const response = await unLockDeclarations(declId)
      return response.data.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: EntityLegalDeclarationApi'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return null
    }
  }
}
